import React from 'react'
import Moment from 'moment'

import unsnoozePerson from '../../actions/unsnoozePerson'

const SnoozeStatus = ({person}) => {
  if (!person.showAsSnoozed) {
    return null
  }
  return <div style={{color: 'orange'}}>
    <hr />
    snoozed until {Moment(person.nextTouch).format('MMM Do')}
    {' - '}
    <span onClick={() => unsnoozePerson(person.id)}>remove</span>
  </div>
}

export default SnoozeStatus



// WEBPACK FOOTER //
// ./src/views/person/SnoozeStatus.js